/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewPasswordRules/view.blocks to change it.
import ArrowLeftLong from 'DesignSystem/Svgs/ArrowLeftLong/index'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NewPasswordRules({
  children,
  viewPath = "/DesignSystem/NewPasswordRules"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="NewPasswordRules.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Make sure the password meets the following requirements:"
 fontSize={12}
 whiteSpace="wrap"
/>
<div
  data-testid="NewPasswordRules.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ArrowLeftLong
  viewPath={`${viewPath}/ArrowLeftLong`}
 width={10}
 height={10}
 marginRight={8}
/>
<Info
  viewPath={`${viewPath}/Info`}
 text="8 characters"
 fontSize={12}
 marginTop={2}
 whiteSpace="wrap"
/>
</div>
<div
  data-testid="NewPasswordRules.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ArrowLeftLong
  viewPath={`${viewPath}/ArrowLeftLong`}
 width={10}
 height={10}
 marginRight={8}
/>
<Info
  viewPath={`${viewPath}/Info`}
 text="One number"
 fontSize={12}
 marginTop={2}
 whiteSpace="wrap"
/>
</div>
<div
  data-testid="NewPasswordRules.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<ArrowLeftLong
  viewPath={`${viewPath}/ArrowLeftLong`}
 width={10}
 height={10}
 marginRight={8}
/>
<Info
  viewPath={`${viewPath}/Info`}
 text="One capital letter"
 fontSize={12}
 marginTop={2}
 whiteSpace="wrap"
/>
</div>
<div
  data-testid="NewPasswordRules.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<ArrowLeftLong
  viewPath={`${viewPath}/ArrowLeftLong`}
 width={10}
 height={10}
 marginRight={8}
/>
<Info
  viewPath={`${viewPath}/Info`}
 text="One lower case letter"
 fontSize={12}
 marginTop={2}
 whiteSpace="wrap"
/>
</div>
<div
  data-testid="NewPasswordRules.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<ArrowLeftLong
  viewPath={`${viewPath}/ArrowLeftLong`}
 width={10}
 height={10}
 marginRight={8}
/>
<Info
  viewPath={`${viewPath}/Info`}
 text="One special character !@&"
 fontSize={12}
 marginTop={2}
 whiteSpace="wrap"
/>
</div>
</div>
{children}
</React.Fragment>)
}